import { routerReducer } from '@angular-redux/router';

import {
    accountTicketsReducer,
    applicationReducer,
    areasReducer,
    cardGroupReducer,
    cardInfoReducer,
    customerReducer,
    notificationReducer,
    paymentMethodsReducer,
    personalizeReducer,
    productsByChannelReducer,
    productCategoriesReducer,
    productsSelectorReducer,
    purchaseHistoryReducer,
    purchaseMediumReducer,
    purchaseReducer,
    realtimeReducer,
    relatedCardReducer,
    scheduleReducer,
    shoppingCartReducer,
    stopsReducer,
    swishReducer,
    ticketsReducer,
    travellersReducer,
    validationHistoryReducer,
    AccountTicketsState,
    ApplicationState,
    AreasState,
    AuthReducer,
    AuthState,
    ACCOUNT_TICKETS_INITIAL_STATE,
    ACCOUNT_TICKETS_STATE_KEY,
    APPLICATION_INITIAL_STATE,
    APPLICATION_STATE_KEY,
    AREAS_INITIAL_STATE,
    AUTH_INITIAL_STATE,
    AUTH_STATE_KEY,
    CardGroupState,
    CardInfoState,
    CustomerState,
    CARD_GROUP_INITIAL_STATE,
    CARD_INFO_INITIAL_STATE,
    CARD_INFO_STATE_KEY,
    CUSTOMER_INITIAL_STATE,
    CUSTOMER_STATE_KEY,
    NotificationState,
    NOTIFICATION_INITIAL_STATE,
    NOTIFICATION_STATE_KEY,
    PaymentMethodsState,
    PersonalizeState,
    ProductsByChannelState,
    ProductCategoriesState,
    ProductsSelectorState,
    PurchaseHistoryState,
    PurchaseMediumState,
    PurchaseState,
    PAYMENT_METHODS_INITIAL_STATE,
    PERSONALIZE_INITIAL_STATE,
    PERSONALIZE_STATE_KEY,
    ISIC_CARD_INITIAL_STATE,
    ISIC_CARD_STATE_KEY,
    PRODUCT_CATEGORIES_INITIAL_STATE,
    PRODUCTS_BY_CHANNEL_INITIAL_STATE,
    PRODUCTS_SELECTOR_INITIAL_STATE,
    PURCHASE_HISTORY_INITIAL_STATE,
    PURCHASE_HISTORY_STATE_KEY,
    PURCHASE_INITIAL_STATE,
    PURCHASE_MEDIUM_INITIAL_STATE,
    PURCHASE_MEDIUM_STATE_KEY,
    PURCHASE_STATE_KEY,
    RealtimeState,
    RelatedCardState,
    REALTIME_INITIAL_STATE,
    RELATED_CARD_INITIAL_STATE,
    RELATED_CARD_STATE_KEY,
    ScheduleState,
    ShoppingCartState,
    StopsState,
    SwishState,
    SCHEDULE_INITIAL_STATE,
    SCHEDULE_STATE_KEY,
    SHOPPING_CART_INITIAL_STATE,
    SHOPPING_CART_STATE_KEY,
    STOPS_INITIAL_STATE,
    STOPS_STATE_KEY,
    SWISH_INITIAL_STATE,
    TicketsState,
    TravellersState,
    TICKETS_INITIAL_STATE,
    TRAVELLERS_INITIAL_STATE,
    ValidationHistoryState,
    VALIDATION_HISTORY_INITIAL_STATE,
    VALIDATION_HISTORY_STATE_KEY,
    BANKCARD_TICKETS_STATE_KEY,
    BankcardTicketsState,
    BANKCARD_TICKETS_INITIAL_STATE,
    bankcardTicketsReducer,
    IsicCardState,
    isicCardReducer,
    RidePlannerState,
    RIDE_PLANNER_STATE_KEY,
    RIDE_PLANNER_INITIAL_STATE,
    ridePlannerReducer,
    RIDE_HISTORY_STATE_KEY,
    RIDE_BOOKINGS_STATE_KEY,
    RideHistoryState,
    RideBookingsState,
    RIDE_HISTORY_INITIAL_STATE,
    RIDE_BOOKINGS_INITIAL_STATE,
    rideBookingsReducer,
    rideHistoryReducer,
    PRODUCTS_SELECTOR_STATE_KEY
} from '@ridango/components';
import { PAYMENT_METHODS_STATE_KEY } from '@ridango/components/lib/payment-methods/+state/payment-methods.reducer';
import { PRODUCTS_BY_CHANNEL_STATE_KEY } from '@ridango/components/lib/products/+state/products.reducer';
import { coreReducer, CoreState, CORE_INITIAL_STATE } from '@ridango/core';

import { combineReducers } from 'redux';

export interface AppState {
    [ACCOUNT_TICKETS_STATE_KEY]: AccountTicketsState;
    [APPLICATION_STATE_KEY]: ApplicationState;
    areas: AreasState;
    [AUTH_STATE_KEY]: AuthState;
    card_group: CardGroupState;
    [CARD_INFO_STATE_KEY]: CardInfoState;
    [SHOPPING_CART_STATE_KEY]: ShoppingCartState;
    core: CoreState;
    [CUSTOMER_STATE_KEY]: CustomerState;
    [PURCHASE_MEDIUM_STATE_KEY]: PurchaseMediumState;
    [NOTIFICATION_STATE_KEY]: NotificationState;
    [PAYMENT_METHODS_STATE_KEY]: PaymentMethodsState;
    productCategories: ProductCategoriesState;
    realtime: RealtimeState;
    [PRODUCTS_BY_CHANNEL_STATE_KEY]: ProductsByChannelState;
    [PRODUCTS_SELECTOR_STATE_KEY]: ProductsSelectorState;
    [PURCHASE_STATE_KEY]: PurchaseState;
    [PURCHASE_HISTORY_STATE_KEY]: PurchaseHistoryState;
    [VALIDATION_HISTORY_STATE_KEY]: ValidationHistoryState;
    [RELATED_CARD_STATE_KEY]: RelatedCardState;
    [PERSONALIZE_STATE_KEY]: PersonalizeState;
    [ISIC_CARD_STATE_KEY]: IsicCardState;
    tickets: TicketsState;
    travellers: TravellersState;
    router: any;
    [STOPS_STATE_KEY]: StopsState;
    swish: SwishState;
    [SCHEDULE_STATE_KEY]: ScheduleState;
    [BANKCARD_TICKETS_STATE_KEY]: BankcardTicketsState;
    [RIDE_PLANNER_STATE_KEY]: RidePlannerState;
    [RIDE_HISTORY_STATE_KEY]: RideHistoryState;
    [RIDE_BOOKINGS_STATE_KEY]: RideBookingsState;
}

export const INITIAL_STATE: AppState = {
    [ACCOUNT_TICKETS_STATE_KEY]: ACCOUNT_TICKETS_INITIAL_STATE,
    [APPLICATION_STATE_KEY]: APPLICATION_INITIAL_STATE,
    areas: AREAS_INITIAL_STATE,
    [AUTH_STATE_KEY]: AUTH_INITIAL_STATE,
    card_group: CARD_GROUP_INITIAL_STATE,
    cardInfo: CARD_INFO_INITIAL_STATE,
    [SHOPPING_CART_STATE_KEY]: SHOPPING_CART_INITIAL_STATE,
    core: CORE_INITIAL_STATE,
    [CUSTOMER_STATE_KEY]: CUSTOMER_INITIAL_STATE,
    [PURCHASE_MEDIUM_STATE_KEY]: PURCHASE_MEDIUM_INITIAL_STATE,
    [NOTIFICATION_STATE_KEY]: NOTIFICATION_INITIAL_STATE,
    [PAYMENT_METHODS_STATE_KEY]: PAYMENT_METHODS_INITIAL_STATE,
    productCategories: PRODUCT_CATEGORIES_INITIAL_STATE,
    realtime: REALTIME_INITIAL_STATE,
    [PRODUCTS_BY_CHANNEL_STATE_KEY]: PRODUCTS_BY_CHANNEL_INITIAL_STATE,
    [PRODUCTS_SELECTOR_STATE_KEY]: PRODUCTS_SELECTOR_INITIAL_STATE,
    [PURCHASE_STATE_KEY]: PURCHASE_INITIAL_STATE,
    [PURCHASE_HISTORY_STATE_KEY]: PURCHASE_HISTORY_INITIAL_STATE,
    [VALIDATION_HISTORY_STATE_KEY]: VALIDATION_HISTORY_INITIAL_STATE,
    [RELATED_CARD_STATE_KEY]: RELATED_CARD_INITIAL_STATE,
    [PERSONALIZE_STATE_KEY]: PERSONALIZE_INITIAL_STATE,
    [ISIC_CARD_STATE_KEY]: ISIC_CARD_INITIAL_STATE,
    tickets: TICKETS_INITIAL_STATE,
    travellers: TRAVELLERS_INITIAL_STATE,
    router: '',
    [STOPS_STATE_KEY]: STOPS_INITIAL_STATE,
    swish: SWISH_INITIAL_STATE,
    [SCHEDULE_STATE_KEY]: SCHEDULE_INITIAL_STATE,
    [BANKCARD_TICKETS_STATE_KEY]: BANKCARD_TICKETS_INITIAL_STATE,
    [RIDE_PLANNER_STATE_KEY]: RIDE_PLANNER_INITIAL_STATE,
    [RIDE_HISTORY_STATE_KEY]: RIDE_HISTORY_INITIAL_STATE,
    [RIDE_BOOKINGS_STATE_KEY]: RIDE_BOOKINGS_INITIAL_STATE
};

export const rootReducer = combineReducers<AppState>({
    [ACCOUNT_TICKETS_STATE_KEY]: accountTicketsReducer,
    [APPLICATION_STATE_KEY]: applicationReducer,
    areas: areasReducer,
    [AUTH_STATE_KEY]: AuthReducer,
    card_group: cardGroupReducer,
    cardInfo: cardInfoReducer,
    [SHOPPING_CART_STATE_KEY]: shoppingCartReducer,
    core: coreReducer,
    [CUSTOMER_STATE_KEY]: customerReducer,
    [PURCHASE_MEDIUM_STATE_KEY]: purchaseMediumReducer,
    [NOTIFICATION_STATE_KEY]: notificationReducer,
    payment: paymentMethodsReducer,
    productCategories: productCategoriesReducer,
    realtime: realtimeReducer,
    [PRODUCTS_BY_CHANNEL_STATE_KEY]: productsByChannelReducer,
    [PRODUCTS_SELECTOR_STATE_KEY]: productsSelectorReducer,
    [PURCHASE_STATE_KEY]: purchaseReducer,
    [PURCHASE_HISTORY_STATE_KEY]: purchaseHistoryReducer,
    [VALIDATION_HISTORY_STATE_KEY]: validationHistoryReducer,
    [RELATED_CARD_STATE_KEY]: relatedCardReducer,
    [PERSONALIZE_STATE_KEY]: personalizeReducer,
    [ISIC_CARD_STATE_KEY]: isicCardReducer,
    tickets: ticketsReducer,
    travellers: travellersReducer,
    router: routerReducer,
    [STOPS_STATE_KEY]: stopsReducer,
    swish: swishReducer,
    [SCHEDULE_STATE_KEY]: scheduleReducer,
    [BANKCARD_TICKETS_STATE_KEY]: bankcardTicketsReducer,
    [RIDE_PLANNER_STATE_KEY]: ridePlannerReducer,
    [RIDE_BOOKINGS_STATE_KEY]: rideBookingsReducer,
    [RIDE_HISTORY_STATE_KEY]: rideHistoryReducer
});
